module.exports = __webpack_public_path__ + "img/text-left.21542645.svg";